import {Lookups} from "./lookups";

export interface Sport extends Lookups {
  id?: number;
  name?: string;
  description?: string;
  created?: Date;
  modified?: Date;
  count?: number;
}

export const SportIconMapping: Record<number, string> = {
  1: '',
  2: '',
  3: '',
  4: '',
  5: '',
  6: '',
  7: '',
  8: '',
  9: '',
  10: '',
  11: '',
  12: '',
  13: '',
  14: '',
  15: '',
  16: '',
  17: '',
  18: '',
  19: '',
  20: '',
  21: '',
  22: '',
  23: '',
  24: '',
  25: '',
  26: '',
  27: '',
  28: '',
  29: '',
  30: 'assets/icons/icons-alt/running_road.svg',
  31: '',
  32: '',
  33: '',
  34: 'assets/icons/icons-alt/sup.svg',
  35: 'assets/icons/icons-alt/swimming.svg',
  36: 'assets/icons/icons-alt/trail_running.svg',
  37: '',
  38: '',
  39: 'assets/icons/icons-alt/volleyball.svg',
  40: '',
  41: '',
  44: '',
  43: ''
};
